<script lang="ts">
  import PageHeadingSection from "../ui/PageHeadingSection.svelte";
</script>

<svelte:head>
  <title>Opłaty i płatności - Kancelaria Notarialna Wrocław</title>
  <meta name="description" content="Opłaty i płatności w kancelarii" />
</svelte:head>

<PageHeadingSection title="Opłaty i płatności" imageUrl="/oplaty-i-platnosci.jpg" />

<section class="section">
  <div class="container">
    <h2 class="heading">Opłaty i płatności</h2>

    <p class="paragraph">
      W związku z dokonywanymi czynnościami notarialnymi Notariusz pobiera
      następujące opłaty:
    </p>
    <ul>
      <li>
        podatek od czynności cywilnoprawnych, który następnie jest przekazywany
        do właściwego Urzędu Skarbowego -
        <a
          class="link"
          target="_blank"
          href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=wdu20000860959"
        >
          zgodnie z ustawą z dnia września 2000 r. o podatku od czynności
          cywilnoprawnych
        </a>
      </li>
      <li>
        podatek od spadków i darowizn, który następnie jest przekazywany do
        właściwego Urzędu Skarbowego -
        <a
          class="link"
          target="_blank"
          href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19830450207"
        >
          zgodnie z dnia 28 lipca 1983 r. o podatku od spadków i darowizn
        </a>
      </li>
      <li>
        opłaty sądowe, które następnie przekazywane są do właściwego sądu
        wieczystoksięgowego -
        <a
          class="link"
          target="_blank"
          href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=wdu20051671398"
        >
          zgodnie z ustawą z dnia 28 lipca 2005 r. o kosztach sądowych w
          sprawach cywilnych
        </a>
      </li>
      <li>
        wynagrodzenie Notariusza (tzw. taksa notarialna) pobierane -
        <a
          class="link"
          target="_blank"
          href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20200001473"
        >
          zgodnie z rozporządzeniem Ministra Sprawiedliwości z dnia 28 czerwca
          2004 r. w sprawie maksymalnych stawek taksy notarialnej</a
        >oraz od podanej w powyższym rozporządzeniu kwoty taksy notarialnej za
        czynności doliczany jest podatek od towarów i usług (VAT) w stawce 23%,
      </li>
      <li>
        opłatę za umieszczenie w Centralnym Repozytorium Elektronicznych Wypisów
        Aktów Notarialnych (CREWAN) elektronicznego wypisu aktu notarialnego
        przeznaczonego dla Szefa Krajowej Administracji Skarbowej, która w
        całości przekazana zostanie do Krajowej Rady Notarialnej -
        <a
          class="link"
          target="_blank"
          href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20230000378"
        >
          zgodnie z rozporządzeniem Ministra Finansów z dnia 28 lutego 2023r. w
          sprawie przechowywania w Centralnym Repozytorium Elektronicznych
          Wypisów Aktów Notarialnych aktów notarialnych, zarejestrowanych aktów
          poświadczenia dziedziczenia i zarejestrowanych europejskich
          poświadczeń spadkowych.
        </a>
      </li>
    </ul>

    <p class="paragraph">
      W celu określenia kosztów czynności notarialnej prosimy o kontakt z
      Kancelarią. Zapytania prosimy składać drogą elektroniczną, telefoniczną
      lub osobiście.
    </p>

    <p class="paragraph">
      W Kancelarii istnieje możliwość płatności wynagrodzenie notarialnego
      brutto kartą lub Blikiem.
      <img 
        src="/blik.svg" 
        class="payment-icon payment-icon--blik" 
        alt="Blik"
      />
      <img src="/visa.svg" class="payment-icon" alt="Visa" />
      <img src="/mastercard.svg" class="payment-icon" alt="Mastercard" />
    </p>

    <p class="paragraph">
      Pozostałe opłaty z uwagi na fakt, iż notariusz przekazuje je odpowiednio
      na rachunki sądu wieczystoksięgowego oraz Urzędu Skarbowego muszą zostać
      uregulowane przelewem lub gotówką na miejscu.
    </p>

    <p class="paragraph">
      Zapłata całości kosztów umowy lub samego podatku od czynności
      cywilnoprawnych/ podatku od spadków i darowizn oraz opłat sądowych może
      nastąpić również przelewem przed umową, przy czym wpłata musi być
      zaksięgowana na koncie Kancelarii przed rozpoczęciem czynności.
    </p>
  </div>
</section>

<section class="section pt-0">
  <div class="container">
    <h2 class="heading">Numery kont</h2>

    <p class="paragraph">
      Rachunek bieżący (wpłaty podatków, opłat sądowych, taksy notarialnej):
    </p>

    <p class="paragraph fw-bold">63 1140 2004 0000 3002 8379 4748</p>

    <p class="paragraph">prowadzony w mBank S. A. z siedzibą w Warszawie</p>

    <p class="paragraph">
      Rachunek depozytowy w PLN (tylko do wpłat depozytów notarialnych):
    </p>

    <p class="paragraph fw-bold">07 1140 2004 0000 3302 8384 9056</p>

    <p class="paragraph">prowadzony w mBank S. A. z siedzibą w Warszawie</p>

    <p class="paragraph">
      Numer rachunku depozytowego w EURO wskazujemy indywidualnie na życzenie
      klienta.
    </p>
  </div>
</section>

<style>
  .payment-icon {
    height: 50px;
  }

  .payment-icon--blik {
    height: 30px;
  }
</style>
